"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mandatory = {
    presence: { allowEmpty: false }
};
exports.email = {
    presence: { allowEmpty: false },
    email: true
};
exports.radioButton = {
    presence: { allowEmpty: false },
    inclusion: ["yes", "no"]
};
exports.money = {
    presence: { allowEmpty: false },
    numericality: {
        greaterThan: 0
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsaWRhdGlvbnMuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9saWIvZnVuY3Rpb25zL3ZhbGlkYXRpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQWEsUUFBQSxTQUFTLEdBQUc7SUFDckIsUUFBUSxFQUFFLEVBQUMsVUFBVSxFQUFFLEtBQUssRUFBQztDQUNoQyxDQUFBO0FBRVksUUFBQSxLQUFLLEdBQUc7SUFDakIsUUFBUSxFQUFFLEVBQUMsVUFBVSxFQUFFLEtBQUssRUFBQztJQUM3QixLQUFLLEVBQUUsSUFBSTtDQUNkLENBQUE7QUFFWSxRQUFBLFdBQVcsR0FBRztJQUN2QixRQUFRLEVBQUUsRUFBQyxVQUFVLEVBQUUsS0FBSyxFQUFDO0lBQzdCLFNBQVMsRUFBRSxDQUFDLEtBQUssRUFBRSxJQUFJLENBQUM7Q0FDM0IsQ0FBQTtBQUVZLFFBQUEsS0FBSyxHQUFHO0lBQ2pCLFFBQVEsRUFBRSxFQUFDLFVBQVUsRUFBRSxLQUFLLEVBQUM7SUFDN0IsWUFBWSxFQUFFO1FBQ1YsV0FBVyxFQUFFLENBQUM7S0FDakI7Q0FDSixDQUFBIn0=